import { lazy } from 'react';
import { Route } from 'react-router-dom';
import { ProtectedLayout } from '../features/layout/ProtectedLayout/ProtectedLayout';

// Lazy loaded components
const ReassignPatientsPageComponent = lazy(() => import('../features/reassignPatients/component/ReassignPatientsPageComponent/ReassignPatientsPageComponent'));
const BatchMessagingPageComponent = lazy(() => import('../features/batchMessagingTool/component/BatchMessagingPageComponent/BatchMessagingPageComponent'));
const BatchUploadingPatientPageComponent = lazy(() => import('../features/batchUploadPatientTool/component/BatchUploadPatientPageComponent/BatchUploadingPatientPageComponent'));
const InternalToolLayoutComponent = lazy(() => import('../features/adminPortal2/layout/InternalToolLayoutComponent/InternalToolLayoutComponent'));
export const createInternalToolRoutes = () => (
  <Route path="/internal-tool">
    <Route
      element={(
        <ProtectedLayout />
      )}
    >
      <Route element={<InternalToolLayoutComponent />}>
        <Route
          path="/internal-tool/reassign-patients"
          element={<ReassignPatientsPageComponent />}
        />
        <Route
          path="/internal-tool/batch-messaging"
          element={<BatchMessagingPageComponent />}
        />
        <Route
          path="/internal-tool/batch-uploading"
          element={<BatchUploadingPatientPageComponent />}
        />
      </Route>
    </Route>
  </Route>
);

export default createInternalToolRoutes;
